import { Box, Button, Divider, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../utils"
import { Trans, useTranslation } from "react-i18next"
import TransMsg from './transMessage'
import { useSnackbar } from "../../contexts"
import { contactFaqUrl, supportMailUrl } from "../../constants"

const styles = {
    regularText: {
        ...theme.typography.poppinsBodyRegular,
        fontSize: "18px",
        color: "#1E1E22"
    },
    mainCaption: {
        ...theme.typography.opticianBodyRegular,
        lineHeight: "100%",
        mt: "23px",
        fontSize: "48px"
    },
    mediumCaption: {
        ...theme.typography.body1Medium,
        fontSize: "20px",
        color: "#000",
        textTransform: 'capitalize'
    },
    contactCard: {
        borderRadius: "16px",
        backgroundColor: "#F8F8F8",
        p: "27px 10px 27px 36px",
        mt: "40px",
        width: "388px"
    },
    underlineText: {
        ...theme.typography.poppinsBodyRegular,
        fontWeight: 700,
        fontSize: "16px",
        textDecoration: "underline",
        color: "#1E1E22",
        textDecorationColor: theme?.palette?.primary?.main,
        textUnderlineOffset: "5px",
        textDecorationThickness: "2px"
    }
}
export const ContactUs = () => {
    const { t } = useTranslation()
    const { showSnackbar } = useSnackbar();
    const isMobile = useMediaQuery(theme.breakpoints.down(950))
    const isMobileX = useMediaQuery(theme.breakpoints.down(450))

    const openUrlInNewTab = (url: any) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
        else {
            showSnackbar("link is not available!", "error")
        }
    }

    const openFaqs = () => {
        const faqUrl = contactFaqUrl
        openUrlInNewTab(faqUrl)
    }

    return (
        <Box sx={{ mt: "60px", py: "50px", px: isMobile ? "31px" : "181px" }} textAlign={"left"}>
            <Typography sx={styles.regularText}>CONTACT US</Typography>
            <Typography sx={styles.mainCaption}>
                <Trans
                    i18nKey={t(TransMsg.EXPERIENCE_CAPTION)}
                    components={{ br: <br /> }} />
            </Typography>
            <Typography sx={[styles.regularText, { mt: "23px" }]}>
                <Trans
                    i18nKey={t(TransMsg.FEEDBACK_DESCRIPTION)}
                    components={{ br: <br /> }} />
            </Typography>

            <Divider sx={{ mt: "40px", backgroundColor: "#CDCBCA" }} />

            <Box display={"flex"} gap="1rem" flexWrap={"wrap"}>
                <Box sx={styles.contactCard}>
                    <Typography sx={[styles.mediumCaption, { textTransform: 'uppercase' }]}>{t(TransMsg.NEED_HELP)}</Typography>
                    <Typography sx={[styles.regularText, { mt: "23px", fontSize: "16px" }]}>
                        <Trans
                            i18nKey={t(TransMsg.HELP_DESCRIPTION)}
                            components={{ br: <br />, bold: <strong /> }} />
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: 'center', mr: "26px" }}>
                        <Button
                            variant='contained'
                            onClick={openFaqs}
                            sx={{ width: "200px", mt: "23px", height: "38px", borderRadius: "8px" }}>
                            <Typography
                                sx={{ ...theme.typography.poppinsBodySemiBold, fontSize: "14px", color: "#fff", textTransform: 'capitalize' }}>
                                {t(TransMsg.OPEN_FAQS_LABEL)}
                            </Typography>
                        </Button>
                    </Box>
                </Box>
                <Box sx={styles.contactCard}>
                    <Typography sx={[styles.mediumCaption, { textTransform: 'uppercase' }]}>{t(TransMsg.PREFER_MAIL)}</Typography>
                    <Typography sx={[styles.regularText, { mt: "23px", fontSize: "16px" }]}>
                        <Trans
                            i18nKey={t(TransMsg.REACH_MAIL)}
                            components={{
                                br: isMobileX ?<br /> : <></>,
                                // eslint-disable-next-line jsx-a11y/anchor-has-content
                                a: <a
                                    href={`mailto:${supportMailUrl}`}
                                    style={styles.underlineText}></a>
                            }} />
                    </Typography>
                    <Typography sx={[styles.regularText, { mt: "16px", fontSize: "16px" }]}>{t(TransMsg.RESPOND_DESCRIPTION)}</Typography>
                </Box>
            </Box>
        </Box>
    )
}